
<div class="customer-favorites"> 
    <h1>Mes favoris à acheter ({{ (myBuyCars$ | async)!.length }})</h1>
    
    <div class="buttons-section"> 
    </div>

    <app-car-card-list 
        [fetchingResults]="(fetchingResults$ | async)!" 
        [cars]="(myBuyCars$ | async)!" 
        [businessLine]="businessLine!"
        >
    </app-car-card-list>
<!--     
    <h1>Mes alertes</h1>
    <app-alerts
        [alerts]="(myProfile$ | async)!.alerts"
        >
    </app-alerts> 

    <app-car-box-list 
        [fetchingResults]="(fetchingResults$ | async)!" 
        [cars]="(myBuyCars$ | async)!" 
        [businessLine]="businessLine!"
        >
    </app-car-box-list>

    -->
</div>

